import { ProfileTransformer } from "@/types/transformers/profile";
import { Profile } from "../profile";
import { AxiosResponse } from "axios";
import { GetProfileByIdRes } from "@/api/profiles";
import { getBannedAvatar } from "@/utils/banned";

export class ProfileViewModel {
    profile: Profile | null = null

    setData(profile: Profile | null) {
        this.profile = profile
        return this
    }
    
    get mainPhotoUrl(): string | null {
        if (!this.profile)
            return null
        const photos = this.profile.photos
        if (photos.length)
            return photos[0].main_url
        return null
    }

    isBanned(): boolean {
        if (!this.profile)
            return false
        return this
            .profile
            .is_banned
            === true
    }

    isPremium(): boolean {
        if (!this.profile)
            return false
        return this
            .profile
            .is_paid
            === true
    }

    get bannedAvatar(): string {        
        if (!this.profile)
            return ''
        return getBannedAvatar(this.profile)
    }

    get name(): string {        
        if (!this.profile)
            return ''
        return this.profile.public_name ?? ''
    }

    get age(): number {        
        if (!this.profile)
            return 0
        return this.profile.age ?? 0
    }

    get accountBannedMsg(): string {        
        const name = this.profile?.public_name
        const gender = this.profile?.gender
        if (
            !name?.length ||
            !gender?.length
        )
            return 'Аккаунт заблокирован'
        return `${name} ${gender === 'male' ? 'заблокирован' : 'заблокирована'}`
    }
}
